import style from "./DeskTopProductDetail.module.scss";
import { AuthContext } from "providers/AuthProvider";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import NiceModal from "@ebay/nice-modal-react";
import { addCommas, clone, decode, rpad2D } from "shared/utils/Utils";
import { storeRequester } from "App";
import Center from "layouts/wrapper/Center";
import P from "components/P";
import VerticalFlex from "layouts/flex/VerticalFlex";
import FlexChild from "layouts/flex/FlexChild";

import Flex from "layouts/flex/Flex";
import SquareWrapper from "layouts/wrapper/SquareWrapper";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import Inline from "layouts/container/Inline";
import PaddingWrapper from "layouts/wrapper/PaddingWrapper";
import initialSearchCondition from "InitialData/InitialSearchCondition.json";
import InputNumber from "components/inputs/InputNumber";
import Container from "layouts/container/Container";
import cartIcon from "resources/img/cartIcon.svg";
import { getCookie } from "shared/StoreRequester";
import { toast } from "react-toastify";
import QuillViewer from "components/inputs/richEditor/QuillViewer";
import Dummy from "components/Dummy";
import { getCustomPriceDisplay } from "shared/utils/Utils";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper";
import ProductCard from "components/card/product/ProductCard";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faAngleRight, faCancel, fas, faShoppingCart, faXmark } from "@fortawesome/free-solid-svg-icons";
import { faHeart as faHeartRegular } from "@fortawesome/free-regular-svg-icons";
import { faHeart as faHeartSolid } from "@fortawesome/free-solid-svg-icons";

function DeskTopProductDetail2() {
  const { isMobile } = useContext(BrowserDetectContext);
  const { userName } = useContext(AuthContext);
  const { id } = useParams();
  const [product, setProduct] = useState();
  const [slideProduct, setSlideProduct] = useState();
  const [mainImage, setMainImage] = useState("");
  const { t } = useTranslation();
  const inputs = useRef({});
  const [items, setItems] = useState([]);
  const [isIncrease, setIsIncrease] = useState(false);
  // const [quantity, setQuantity] = useState(0);
  const [totalPrice, setTotalPrice] = useState(0); // 총 금액 상태
  const [selectedRows, setSelectedRows] = useState([]); // 선택된 row 상태

  const [interests, setInterests] = useState([]);

  const isProductWished = product?.id && interests.some(interest => interest.product_id === product.id);



  useEffect(() => {
    if (inputs.current.length > 0) {
      inputs.current.forEach((input, index) => {
        const value = input?.getValue ? input.getValue() : null;

        if (value !== 0) {
          setItems((prevItems) => {
            const updatedItems = prevItems.map((item) =>
              item.index === index ? { ...item, quantity: value } : item
            );
            return updatedItems;
          });
        } else {
          setItems((prevItems) =>
            prevItems.filter((item) => item.index !== index)
          );
        }
      });
    }
  }, [inputs.current, isIncrease]);
  useEffect(() => {
    let searchCondition = clone(initialSearchCondition);
    searchCondition.productId = id;

    // if (id.startsWith("prod")) {
    storeRequester.getProduct(
      id,
      {
        expand: "images",
        // with_price: true,
        type: "main",
      },
      // ({ product }) => setProduct(product)
      ({ product }) => {
        
        setSlideProduct(rpad2D(product.variants, (isMobile ? 3 : 4)));
        setProduct(product);
        setMainImage(product.thumbnail);
      }
    );

  }, []);

  // 총 금액 계산 함수
  // useEffect(() => {
  //   const total = items.reduce((sum, item) => {
  //     const variant = product.variants.find(
  //       (variant) => variant.id === item.variantId
  //     );

  //     const price = variant?.discount_price || variant?.price || 0;
  //     return sum + price * item.quantity;
  //   }, 0);
  //   setTotalPrice(total);
  // }, [items, product]);

  useEffect(() => {
    const total = selectedRows.reduce((sum, row) => {
      return sum + (row.price * row.quantity);
    }, 0);
    setTotalPrice(total);
  }, [selectedRows]);

  const handleInputChange = (variantId, value) => {
    setItems((prevItems) => {
      const existingItemIndex = prevItems.findIndex(
        (item) => item.variantId === variantId
      );
      const updatedItems = [...prevItems];

      if (existingItemIndex !== -1) {
        // 기존 아이템 업데이트
        updatedItems[existingItemIndex] = {
          ...updatedItems[existingItemIndex],
          quantity: value,
        };
      } else {
        // 새로운 아이템 추가
        updatedItems.push({ variantId, quantity: value });
      }
      return updatedItems;
    });
  };
  const handleAddToCart = () => {
    if (!userName) {
      toast.error(t("로그인해주세요"), {
        autoClose: 1000,
        position: toast.POSITION.BOTTOM_CENTER,
      });
      return;
    }

    const selectedItems = selectedRows.filter(row => row.quantity > 0);

    if (selectedItems.length === 0) {
      toast.error(t("수량을 선택해주세요"), {
        autoClose: 1000,
        position: toast.POSITION.BOTTOM_CENTER,
      });
      return;
    }

    const cartId = getCookie("_medusa_cart_id");
    const items = selectedItems.map(row => ({
      variant_id: row.id,
      quantity: row.quantity,
      free: false
    }));

    storeRequester.addItem(
      cartId,
      items,
      () => toast.success(t("장바구니에 추가되었습니다."), {
        autoClose: 1000,
        position: toast.POSITION.BOTTOM_CENTER,
      })
    );
  };

  const fetchInterests = () => {
    if (!userName) return;
    storeRequester.getInterest(
      (response) => setInterests(response.interests)
    );
  };

  // 관심 상품 토글 핸들러
  const handleWishToggle = async () => {
    if (!userName) {
      toast.error(t("로그인해주세요"), {
        autoClose: 1000,
        position: toast.POSITION.BOTTOM_CENTER,
      });
      return;
    }

    try {
      const isWished = interests.some(interest => interest.product_id === product.id);

      if (isWished) {
        // 관심 상품에서 제거
        const interestToDelete = interests.find(
          interest => interest.product_id === product.id
        );
        if (interestToDelete) {
          await storeRequester.delete(`/customers/me/interests/${interestToDelete.id}`);
          // toast.success(t("관심상품에서 제거되었습니다"), {
          //   autoClose: 1000,
          //   position: toast.POSITION.BOTTOM_CENTER,
          // });
        }
      } else {
        // 관심 상품에 추가
        await storeRequester.postInterest({ product_id: product.id });
        // toast.success(t("관심상품에 추가되었습니다"), {
        //   autoClose: 1000,
        //   position: toast.POSITION.BOTTOM_CENTER,
        // });
      }
      // 관심 상품 목록 갱신
      fetchInterests();
    } catch (error) {
      toast.error(t("처리 중 오류가 발생했습니다"), {
        autoClose: 1000,
        position: toast.POSITION.BOTTOM_CENTER,
      });
    }
  };

  // 배열을 n개씩 나누는 함수
  const chunkArray = (array, size) => {
    const chunked = [];
    for (let i = 0; i < array.length; i += size) {
      chunked.push(array.slice(i, i + size));
    }
    return chunked;
  };

  const renderPrice = () => {
    

    const customDisplay = getCustomPriceDisplay(product.id);
    if (customDisplay) {
      // 배열인 경우 (여러 줄)와 문자열인 경우 (한 줄) 처리
      if (Array.isArray(customDisplay)) {
        return customDisplay.map((line, index) => (
          <div key={index}>{line}</div>
        ));
      }
      return customDisplay;
    }

    if (product.variants?.length > 0 && product.discount_price) {
      return `${addCommas(product.discount_price)} 원`;
    }

    return `${addCommas(product.price)} 원`;
  };

  const handleThumbnailHover = (image) => {
    setMainImage(image); // Hover된 썸네일 이미지를 메인 이미지로 설정
  };

  const handleSelectChange = (variant) => {
    // 중복 확인 후 row 추가
    setSelectedRows((prevRows) => {
      if (!prevRows.some((row) => row.id === variant.id)) {
        return [...prevRows, variant];
      }
      return prevRows; // 중복이면 추가하지 않음
    });
  };

  useEffect(() => {
    if (userName) {
      fetchInterests();
    } else {
      setInterests([]);
    }
  }, [userName]);
  return (
    <div className={style.wrap}>
      {product && (
        <Container backgroundColor={"white"} minWidth={1100} maxWidth={1100}>
          <VerticalFlex gap={80}>
            <FlexChild >
              <Container minWidth={1100} maxWidth={1100} borderBottom={'3px solid #ddd'}>
                <HorizontalFlex gap={40} flexStart>
                  <FlexChild width={"max-content"} >
                    <VerticalFlex gap={40}>
                      <FlexChild>
                        <img
                          src={mainImage}
                          alt="Main Product"
                          style={{
                            width: "100%",
                            maxWidth: "420px",
                            borderRadius: "10px",
                          }}
                        />
                      </FlexChild>
                      <FlexChild>
                        <Container maxWidth={420} minWidth={420}>
                          <Swiper
                            modules={[Pagination, Navigation]}
                            navigation={{
                              nextEl: '.product-detail-swiper-next',
                              prevEl: '.product-detail-swiper-prev',
                            }}
                            // style={{ width: '91%' }}
                            pagination={false}
                            slidesPerView={1}
                            spaceBetween={5} // 슬라이드 간 간격
                            className="product-detail-swiper"
                          >
                            {slideProduct &&
                              slideProduct.map((row, rowIndex) => (
                                <SwiperSlide key={rowIndex}>
                                  <Swiper
                                    modules={[Pagination, Navigation]}
                                    style={{ width: "90%" }}
                                    pagination={{ clickable: true }}
                                    slidesPerView={5}
                                    spaceBetween={5}
                                  >
                                    {
                                      rowIndex === 0 &&
                                      <SwiperSlide>
                                        <div
                                          onMouseEnter={() => handleThumbnailHover(product.thumbnail)} // Hover 이벤트
                                          style={{
                                            cursor: "pointer",
                                            border:
                                              mainImage === product.thumbnail ? "1.5px solid var(--main-color)" : "none", // 선택된 이미지 표시

                                            // padding: "1px",
                                            boxSizing: "border-box",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            borderRadius: "3px"

                                          }}
                                        >
                                          <img
                                            src={product.thumbnail}
                                            style={{
                                              maxWidth: '70px',
                                              borderRadius: "3px"
                                            }}
                                          />
                                        </div>
                                      </SwiperSlide>
                                    }

                                    {row.map((item, index) =>
                                      item?.id ? ( // 유효한 데이터인지 확인
                                        <SwiperSlide key={index}>
                                          <div
                                            onMouseEnter={() => handleThumbnailHover(item.thumbnail)} // Hover 이벤트
                                            style={{
                                              cursor: "pointer",
                                              border:
                                                mainImage === item.thumbnail ? "1.5px solid var(--main-color)" : "none", // 선택된 이미지 표시

                                              // padding: "1px",
                                              boxSizing: "border-box",
                                              display: "flex",
                                              justifyContent: "center",
                                              alignItems: "center",
                                              borderRadius: "3px"

                                            }}
                                          >
                                            <img
                                              src={item.thumbnail}
                                              alt={item.title || `Image ${index}`}
                                              style={{
                                                maxWidth: '70px',
                                                borderRadius: "3px"
                                              }}
                                            />
                                          </div>

                                        </SwiperSlide>
                                      ) : (
                                        // 데이터가 없으면 빈 박스 표시
                                        <SwiperSlide key={index}>
                                          <div
                                            style={{
                                              maxWidth: '70px',
                                              background: '#f0f0f0',
                                              borderRadius: "3px"
                                            }}
                                          ></div>
                                        </SwiperSlide>
                                      )
                                    )}
                                  </Swiper>
                                </SwiperSlide>
                              ))}
                          </Swiper>

                          {/* 커스텀 Prev 버튼 */}
                          <div
                            className="product-detail-swiper-prev"
                            style={{
                              position: 'absolute',
                              top: '30%',
                              left: '0px',
                              transform: 'translateY(-50%)',
                              zIndex: 10,
                              width: 0,
                              height: 0,
                              // borderStyle: 'solid',
                              // borderWidth: '10px 15px 10px 0',
                              // borderColor: 'transparent rgba(41, 106, 255, 1) transparent transparent',
                              cursor: 'pointer',
                            }}
                          >
                            <FontAwesomeIcon icon={faAngleLeft} />
                          </div>

                          {/* 커스텀 Next 버튼 */}
                          <div
                            className="product-detail-swiper-next"
                            style={{
                              position: 'absolute',
                              top: '30%',
                              right: '0px',
                              transform: 'translateY(-50%)',
                              zIndex: 10,
                              width: 0,
                              height: 0,
                              // borderStyle: 'solid',
                              // borderWidth: '10px 0 10px 15px',
                              // borderColor: 'transparent transparent transparent rgba(41, 106, 255, 1)',
                              cursor: 'pointer',
                            }}
                          >
                            <FontAwesomeIcon icon={faAngleRight} />
                          </div>

                        </Container>
                      </FlexChild>
                    </VerticalFlex>
                  </FlexChild>
                  <FlexChild>
                    <VerticalFlex gap={17}>
                      <FlexChild >
                        <VerticalFlex gap={20}>
                          <FlexChild>
                            <VerticalFlex gap={10}>
                              <FlexChild>
                                <Center width={"100%"} textAlign={"left"}>
                                  <P size={18} color={"rgba(196,196,196,1)"} weight={600}>
                                    {product.categories &&
                                      product.categories.length > 0 &&
                                      product.categories?.[0].name}
                                  </P>
                                  <Dummy height={"15px"} />
                                  <P size={24} color={"#444"} weight={700}>
                                    {product.title}
                                  </P>

                                </Center>
                              </FlexChild>
                              <FlexChild>
                                <HorizontalFlex gap={10} justifyContent={"flex-end"}>
                                  <FlexChild justifyContent={"flex-start"}>
                                    <P
                                      width={isMobile ? "150px" : "100%"}
                                      textAlign={"left"}
                                      size={isMobile ? 16 : 32}
                                      weight={"bold"}
                                      color={"black"}
                                      textDecoration={product.currentPrice && "line-through"}
                                    >
                                      {renderPrice()}
                                    </P>
                                  </FlexChild>
                                </HorizontalFlex>
                              </FlexChild>
                            </VerticalFlex>
                            <Dummy height={"50px"} />
                          </FlexChild>
                          <FlexChild>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              {/* Select Box */}
                              <select
                                style={{
                                  width: "100%",
                                  height: "40px",
                                  borderRadius: "5px",
                                  padding: "5px",
                                  fontSize: "16px",
                                  marginBottom: "20px",
                                }}
                                onChange={(e) => {
                                  const selectedId = e.target.value;
                                  const selectedVariant = product.variants.find(
                                    (variant) => variant.id === selectedId
                                  );
                                  if (
                                    selectedVariant &&
                                    !selectedRows.some((row) => row.id === selectedVariant.id)
                                  ) {
                                    setSelectedRows((prev) => [
                                      ...prev,
                                      { ...selectedVariant, quantity: 1 },
                                    ]);
                                  }
                                }}
                              >
                                <option value="" disabled selected>
                                  제품을 선택하세요
                                </option>
                                {product.variants.map((variant) => (
                                  <option
                                    key={variant.id}
                                    value={variant.id}
                                    disabled={
                                      variant.inventory_quantity === 0 || variant.sold === true
                                    } // 품절 항목 비활성화
                                  >
                                    {variant.title}
                                    {variant.inventory_quantity === 0 || variant.sold === true
                                      ? " (품절)"
                                      : ""}
                                  </option>
                                ))}
                              </select>

                              {/* 선택된 row들 */}
                              {
                                selectedRows && selectedRows.length > 0 ?
                                  <div
                                    style={{
                                      height: "260px",
                                      overflowY: "scroll",
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: "10px",
                                    }}
                                  >
                                    {selectedRows.map((variant, rowIndex) => (
                                      <div
                                        key={rowIndex}
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "space-between",
                                          padding: "10px",
                                          background: variant.inventory_quantity === 0 || variant.sold === true
                                            ? "#f5f5f5"
                                            : "#f9f9f9",
                                          border: "1px solid #ddd",
                                          borderRadius: "5px",
                                          gap: "20px",
                                          opacity:
                                            variant.inventory_quantity === 0 || variant.sold === true
                                              ? 0.5
                                              : 1,
                                        }}
                                      >

                                        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                          <img
                                            src={variant.thumbnail}
                                            alt={variant.title}
                                            style={{
                                              width: "50px",
                                              height: "50px",
                                              borderRadius: "5px",
                                              objectFit: "cover",
                                              opacity: variant.inventory_quantity === 0 ? 0.5 : 1,
                                            }}
                                          />
                                          <P weight={700} size={16}>
                                            {variant.title}
                                            {variant.inventory_quantity === 0 || variant.sold === true
                                              ? " (품절)"
                                              : ""}
                                          </P>
                                        </div>


                                        {variant.inventory_quantity > 0 && !variant.sold ? (
                                          <div style={{ display: "flex", alignItems: "center", gap: "10px", width: "max-content" }}>
                                            <button
                                              onClick={() =>
                                                setSelectedRows((prev) =>
                                                  prev.map((row) =>
                                                    row.id === variant.id
                                                      ? { ...row, quantity: Math.max(row.quantity - 1, 1) }
                                                      : row
                                                  )
                                                )
                                              }
                                              style={{
                                                width: "30px",
                                                height: "30px",
                                                textAlign: "center",
                                                border: "1px solid #ccc",
                                                borderRadius: "3px",
                                                background: "white",
                                                cursor: "pointer",
                                              }}
                                            >
                                              -
                                            </button>
                                            <input
                                              type="number"
                                              value={variant.quantity}
                                              min={1}
                                              max={
                                                variant.inventory_quantity ===
                                                  0 ||
                                                  variant.sold === true
                                                  ? 0
                                                  : variant.inventory_quantity
                                              }
                                              onChange={(e) => {
                                                const value = Math.max(
                                                  1,
                                                  Math.min(
                                                    Number(e.target.value) || 1,
                                                    variant.inventory_quantity
                                                  )
                                                );
                                                setSelectedRows((prev) =>
                                                  prev.map((row) =>
                                                    row.id === variant.id ? { ...row, quantity: value } : row
                                                  )
                                                );
                                              }}
                                              style={{
                                                width: "50px",
                                                textAlign: "center",
                                                border: "1px solid #ccc",
                                                borderRadius: "3px",
                                                padding: "5px",
                                              }}
                                            />
                                            <button
                                              onClick={() =>
                                                setSelectedRows((prev) =>
                                                  prev.map((row) =>
                                                    row.id === variant.id
                                                      ? { ...row, quantity: row.quantity + 1 }
                                                      : row
                                                  )
                                                )
                                              }
                                              style={{
                                                width: "30px",
                                                height: "30px",
                                                textAlign: "center",
                                                border: "1px solid #ccc",
                                                borderRadius: "3px",
                                                background: "white",
                                                cursor: "pointer",
                                              }}
                                            >
                                              +
                                            </button>
                                          </div>
                                        ) : (
                                          <P size={18} color={"#ca0000"} style={{ margin: "0" }}>
                                            품절
                                          </P>
                                        )}


                                        <div style={{ fontWeight: "bold", fontSize: "16px", width: "25%", }}>
                                          {variant.inventory_quantity > 0 && !variant.sold
                                            ? `${(variant.price * variant.quantity).toLocaleString()}원`
                                            : ""}
                                        </div>


                                        <div
                                          onClick={() =>
                                            setSelectedRows((prev) => prev.filter((row) => row.id !== variant.id))
                                          }
                                          style={{
                                            color: "#fff",

                                            border: "none",
                                            borderRadius: "3px",
                                            padding: "5px 10px",
                                            cursor: "pointer",
                                            width: "max-content",
                                          }}
                                        >
                                          <FontAwesomeIcon icon={faXmark} color={"#aaa"} size={'lg'} />

                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                  :
                                  <div
                                    style={{
                                      height: "260px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center"
                                    }}
                                  >
                                    <Center>
                                      <FontAwesomeIcon
                                        icon={faShoppingCart}
                                        size="8x"
                                        color="var(--main-color)"
                                      />
                                      <Dummy height={"30px"} />
                                      <P color={"#aaa"} weight={700} size={32}>
                                        장바구니가 비었습니다.
                                      </P>
                                    </Center>
                                  </div>
                              }
                            </div>
                          </FlexChild>
                        </VerticalFlex>
                      </FlexChild>
                      <FlexChild>
                        <VerticalFlex gap={20}>
                          <FlexChild alignItems={"flex-end"}>
                            <Inline display={"flex"} alignItems={"flex-end"}>
                              <P size={20} weight={700} color={"#222"}>
                                총 금액 {" "}
                              </P>
                              <P size={32} weight={900} color={"#222"}>
                                {userName ? `${addCommas(totalPrice)}원` : "-"}
                              </P>
                            </Inline>
                          </FlexChild>
                          <FlexChild justifyContent={"flex-end"}>
                            <HorizontalFlex gap={10} justifyContent={"flex-end"}>
                              <FlexChild>
                                <button
                                  onClick={handleWishToggle}
                                  style={{
                                    backgroundColor: "white",
                                    color: "var(--main-color)",
                                    padding: "10px 20px",
                                    border: "1.5px solid var(--main-color)",
                                    borderRadius: "5px",
                                    fontSize: "16px",
                                    cursor: "pointer",
                                    fontWeight: 700,
                                    height: "50px",
                                    width: "95%"
                                  }}
                                >

                                  <FontAwesomeIcon
                                    icon={isProductWished ? faHeartSolid : faHeartRegular}
                                    size={'lg'}
                                    color={isProductWished ? "#ff0000" : "var(--main-color)"}
                                  />
                                  &nbsp;&nbsp;&nbsp;
                                  {isProductWished ? "위시리스트에서 제거" : "위시리스트에 추가"}
                                </button>
                              </FlexChild>
                              <FlexChild width={"60%"}>
                                {/* 일괄 담기 버튼 */}
                                <button
                                  onClick={() => handleAddToCart()}
                                  style={{
                                    backgroundColor: "var(--main-color)",
                                    color: "#fff",
                                    padding: "10px 20px",
                                    border: "none",
                                    borderRadius: "5px",
                                    fontSize: "16px",
                                    cursor: "pointer",
                                    fontWeight: 700,
                                    width: "100%",
                                    height: "50px"
                                  }}
                                >
                                  <img
                                    src={cartIcon}
                                    style={{ color: "white", width: "20px" }}
                                  />{" "}
                                  {/* {userName ? `${addCommas(totalPrice)}원 ` : "-"} */}

                                  장바구니 담기
                                </button>
                              </FlexChild>
                            </HorizontalFlex>
                          </FlexChild>
                        </VerticalFlex>
                      </FlexChild>
                    </VerticalFlex>
                  </FlexChild>
                </HorizontalFlex>
                <Dummy height={50} />
              </Container>
            </FlexChild>
            <FlexChild>
              <PaddingWrapper padding={"0px 10px"}>
                <Container maxWidth={900}>
                  {// to-do remove
                    product?.content ? (
                      <QuillViewer
                        value={
                          product.content?.startsWith("PHA")
                            ? decode(product.content)
                            : product.content
                        }
                      />
                    ) : (
                      <img
                        src={product.images?.[0]?.url}
                        style={{ width: "100%" }}
                        alt="empty"
                      />
                    )}
                </Container>
              </PaddingWrapper>
            </FlexChild>
          </VerticalFlex>
        </Container>
      )}
    </div>
  );
}

export default DeskTopProductDetail2;
